import axios from "axios";
import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";

import { generateTraceId } from "../app/helpers";
import {
  isJusSubNotFoundResponse,
  mapOffersToAdminPlans
} from "../app/services/subscriptionPlanOffers";
import {
  getClientSubscriptionV2,
  mapSubscriptionV2Response
} from "../app/helpers/subscription";
import { config } from "../config/envs";

const INITIAL_STATE = {
  payment_methods_relation: [
    { id: "mastercard", svg: "/media/svg/credit-card/flat/mastercard.svg" },
    { id: "visa", svg: "/media/svg/credit-card/flat/visa.svg" },
    { id: "amex", svg: "/media/svg/credit-card/flat/amex.svg" },
    { id: "hipercard", svg: "/media/svg/credit-card/flat/hipercard.svg" },
    { id: "elo", svg: "/media/svg/credit-card/flat/elo.svg" }
  ],
  default_trial_days: 7,
  cards: [],
  client_subscription: {},
  is_loading_client_subscription: false,
  client_plan_offers: [],
  is_loading_client_plan_offers: false,
  dashboard: {},
  is_dashboard_loading: false,
  customers: [],
  is_customers_loading: false,
  institutions: [],
  institutions_select: [],
  is_institutions_loading: false,
  indexes: [],
  indexes_pf: [],
  indexes_pj: [],
  average_price_indexes: [],
  is_indexes_loading: false,
  periodicity_types: [
    { id: "0", name: "Mensal" },
    { id: "1", name: "Anual" }
  ],
  installment_types: [
    { id: "0", name: "Parcela de Débito" },
    { id: "1", name: "Abatimento / Pagamento" }
  ],
  stakeholder_types: [
    { id: "1", name: "Autor" },
    { id: "2", name: "Credor" },
    { id: "3", name: "Devedor" },
    { id: "4", name: "Réu" }
  ],
  person_types: [
    { id: "pf", name: "Pessoa Física" },
    { id: "pj", name: "Pessoa Jurídica" }
  ],
  amortization_types: [
    { id: "price", name: "Fixas (Price)" },
    { id: "sac", name: "Variáveis (SAC)" }
  ],
  contract_types: [
    { code: "25471", name: "Aquisição de veículos", type: "PF" },
    { code: "25472", name: "Aquisição de outros bens", type: "PF" },
    { code: "25478", name: "Cartão de crédito parcelado", type: "PF" },
    { code: "25477", name: "Cartão de crédito rotativo", type: "PF" },
    { code: "25468", name: "Crédito pessoal consignado INSS", type: "PF" },
    { code: "25463", name: "Cheque especial", type: "PF" },
    {
      code: "25467",
      name: "Crédito pessoal consignado para trabalhadores do setor público",
      type: "PF"
    },
    { code: "25464", name: "Crédito pessoal não consignado", type: "PF" },
    {
      code: "25497",
      name: "Financiamento imobiliário com taxas de mercado",
      type: "PF"
    },
    { code: "25447", name: "Aquisição de veículos", type: "PJ" },
    { code: "25448", name: "Aquisição de bens", type: "PJ" },
    {
      code: "25440",
      name: "Antecipação de faturas de cartão de crédito",
      type: "PJ"
    },
    {
      code: "25442",
      name: "Capital de giro com prazo superior a 365 dias ",
      type: "PJ"
    },
    {
      code: "25441",
      name: "Capital de giro com prazo inferior a 365 dias",
      type: "PJ"
    },
    { code: "25456", name: "Cartão de crédito parcelado", type: "PJ" },
    { code: "25455", name: "Cartão de crédito rotativo", type: "PJ" },
    { code: "25450", name: "Arrendamento mercantil de veículos", type: "PJ" },
    { code: "25446", name: "Cheque especial", type: "PJ" },
    { code: "25445", name: "Conta garantida", type: "PJ" },
    {
      code: "25487",
      name: "Financiamento Imobiliário - Taxa regulada",
      type: "PJ"
    },
    {
      code: "25488",
      name: "Financiamento Imobiliário - Taxa total",
      type: "PJ"
    },
    {
      code: "25498",
      name: "Financiamento Imobiliário - Taxa regulada",
      type: "PF"
    },
    {
      code: "25499",
      name: "Financiamento Imobiliário - Taxa total",
      type: "PF"
    }
  ],
  simulation_result: {
    odds: 0,
    avg_interest_rate: 0,
    original_interest_rate: 0
  },
  is_simulation_loading: false,
  states: [],
  is_states_loading: false,
  cities: [],
  is_cities_loading: false,
  customer: {},
  is_customer_loading: false,
  professions: [],
  is_professions_loading: false,
  is_query_validating_document: false,
  query_available_products: [],
  query_document_type: "",
  query_document_number: "",
  query_checkout_response: {},
  is_activating_account: false,
  account_activation_response: {},
  modal_subscription: {
    visible: false,
    title: "",
    subtitle: "",
    client_id: null,
    callback: () => { }
  },
  modal_subscription_polling: {
    visible: false,
    title: "",
    subtitle: "",
    client_id: null,
    callback: () => { }
  },
  minimum_wages: [],
  coupom: {},
  is_loading_coupom: false,
  is_loading_cards: false
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case "LOAD_CARDS":
    return { ...state, cards: INITIAL_STATE.cards, is_loading_cards: true };
  case "LOAD_CARDS_SUCCESS":
    return { ...state, cards: action.payload, is_loading_cards: false };
  case "LOAD_CARDS_FAILED":
    return { ...state, cards: INITIAL_STATE.cards, is_loading_cards: false };
  case "LOAD_CLIENT_SUBSCRIPTION":
    return {
      ...state,
      client_subscription: INITIAL_STATE.client_subscription,
      is_loading_client_subscription: true
    };
  case "LOAD_CLIENT_SUBSCRIPTION_SUCCESS":
    return {
      ...state,
      client_subscription: action.payload,
      is_loading_client_subscription: false
    };
  case "LOAD_CLIENT_SUBSCRIPTION_FAILED":
    return {
      ...state,
      client_subscription: INITIAL_STATE.client_subscription,
      is_loading_client_subscription: false
    };
  case "LOAD_CLIENT_PLAN_OFFERS":
    return {
      ...state,
      client_plan_offers: INITIAL_STATE.client_plan_offers,
      is_loading_client_plan_offers: true
    };
  case "LOAD_CLIENT_PLAN_OFFERS_SUCCESS":
    return {
      ...state,
      client_plan_offers: action.payload,
      is_loading_client_plan_offers: false
    };
  case "LOAD_CLIENT_PLAN_OFFERS_FAILED":
    return {
      ...state,
      client_plan_offers: INITIAL_STATE.client_plan_offers,
      is_loading_client_plan_offers: false
    };
  case "CLEAR_CLIENT_PLAN_OFFERS":
    return {
      ...state,
      client_plan_offers: INITIAL_STATE.client_plan_offers,
      is_loading_client_plan_offers: false
    };
  case "LOAD_COUPOM":
    return {
      ...state,
      coupom: INITIAL_STATE.coupom,
      is_loading_coupom: true
    };
  case "LOAD_COUPOM_SUCCESS":
    return { ...state, coupom: action.payload, is_loading_coupom: false };
  case "LOAD_COUPOM_FAILED":
    return {
      ...state,
      coupom: INITIAL_STATE.coupom,
      is_loading_coupom: false
    };
  case "LOAD_MINIMUM_WAGES":
    return { ...state, minimum_wages: INITIAL_STATE.minimum_wages };
  case "LOAD_MINIMUM_WAGES_SUCCESS":
    return { ...state, minimum_wages: action.payload };
  case "LOAD_MINIMUM_WAGES_FAILED":
    return { ...state, minimum_wages: INITIAL_STATE.minimum_wages };
  case "LOAD_CALCULATIONS":
    return {
      ...state,
      calculations_loading: true,
      calculations: INITIAL_STATE.calculations
    };
  case "LOAD_CALCULATIONS_SUCCESS":
    return {
      ...state,
      calculations_loading: false,
      calculations: action.payload
    };
  case "LOAD_CALCULATIONS_FAILED":
    return {
      ...state,
      calculations_loading: false,
      calculations: INITIAL_STATE.calculations
    };
  case "SET_CARDS":
    return { ...state, cards: action.payload };
  case "SET_MODAL_SUBSCRIPTION":
    return { ...state, modal_subscription: action.payload };
  case "SET_MODAL_SUBSCRIPTION_POLLING":
    return { ...state, modal_subscription_polling: action.payload };
  case "CLOSE_MODAL_SUBSCRIPTION":
    return {
      ...state,
      modal_subscription: INITIAL_STATE.modal_subscription
    };
  case "CLOSE_MODAL_SUBSCRIPTION_POLLING":
    return {
      ...state,
      modal_subscription_polling: INITIAL_STATE.modal_subscription_polling
    };

  case "ACTIVATE_ACCOUNT":
    return {
      ...state,
      account_activation_response: INITIAL_STATE.account_activation_response,
      is_activating_account: true
    };
  case "ACTIVATE_ACCOUNT_SUCCESS":
    return {
      ...state,
      account_activation_response: action.payload,
      is_activating_account: false
    };
  case "ACTIVATE_ACCOUNT_FAILED":
    return {
      ...state,
      account_activation_response: action.payload,
      is_activating_account: false
    };

  case "LOAD_DASHBOARD":
    return {
      ...state,
      dashboard: INITIAL_STATE.dashboard,
      is_dashboard_loading: true
    };
  case "LOAD_DASHBOARD_SUCCESS":
    return {
      ...state,
      dashboard: action.payload,
      is_dashboard_loading: false
    };
  case "LOAD_DASHBOARD_FAILED":
    return {
      ...state,
      dashboard: INITIAL_STATE.dashboard,
      is_dashboard_loading: false
    };
  case "QUERY_CHECKOUT":
    return {
      ...state,
      query_checkout_response: INITIAL_STATE.query_checkout_response
    };
  case "QUERY_CHECKOUT_SUCCESS":
    return {
      ...state,
      query_checkout_response: action.payload
    };
  case "QUERY_CHECKOUT_FAILED":
    return {
      ...state,
      query_checkout_response: INITIAL_STATE.query_checkout_response
    };
  case "QUERY_VALIDATE_DOCUMENT":
    return {
      ...state,
      is_query_validating_document: true,
      query_available_products: INITIAL_STATE.query_available_products,
      query_document_type: INITIAL_STATE.query_document_type,
      query_document_number: INITIAL_STATE.query_document_number
    };
  case "QUERY_VALIDATE_DOCUMENT_SUCCESS":
    return {
      ...state,
      is_query_validating_document: false,
      query_available_products: action.payload.available_products,
      query_document_type: action.payload.document_type,
      query_document_number: action.payload.document_number
    };
  case "QUERY_VALIDATE_DOCUMENT_FAILED":
    return {
      ...state,
      is_query_validating_document: false,
      query_available_products: INITIAL_STATE.query_available_products,
      query_document_type: INITIAL_STATE.query_document_type,
      query_document_number: INITIAL_STATE.query_document_number
    };
  case "LOAD_SIMULATION":
    return {
      ...state,
      simulation_result: INITIAL_STATE.simulation_result,
      is_simulation_loading: true
    };
  case "LOAD_SIMULATION_SUCCESS":
    return {
      ...state,
      simulation_result: action.payload,
      is_simulation_loading: false
    };
  case "LOAD_SIMULATION_FAILED":
    return {
      ...state,
      simulation_result: INITIAL_STATE.simulation_result,
      is_simulation_loading: false
    };
  case "LOAD_STATES":
    return {
      ...state,
      states: INITIAL_STATE.states,
      is_states_loading: true
    };
  case "LOAD_STATES_SUCCESS":
    return { ...state, states: action.payload, is_states_loading: false };
  case "LOAD_STATES_FAILED":
    return {
      ...state,
      states: INITIAL_STATE.states,
      is_states_loading: false
    };
  case "LOAD_CITIES":
    return {
      ...state,
      cities: INITIAL_STATE.cities,
      is_cities_loading: true
    };
  case "LOAD_CITIES_SUCCESS":
    return { ...state, cities: action.payload, is_cities_loading: false };
  case "LOAD_CITIES_FAILED":
    return {
      ...state,
      cities: INITIAL_STATE.cities,
      is_cities_loading: false
    };
  case "LOAD_CUSTOMER":
    return {
      ...state,
      customer: INITIAL_STATE.customer,
      is_customer_loading: true
    };
  case "LOAD_CUSTOMER_SUCCESS":
    return { ...state, customer: action.payload, is_customer_loading: false };
  case "LOAD_CUSTOMER_FAILED":
    return {
      ...state,
      customer: INITIAL_STATE.customer,
      is_customer_loading: false
    };
  case "LOAD_PROFESSIONS":
    return {
      ...state,
      professions: INITIAL_STATE.professions,
      is_professions_loading: true
    };
  case "LOAD_PROFESSIONS_SUCCESS":
    return {
      ...state,
      professions: action.payload,
      is_professions_loading: false
    };
  case "LOAD_PROFESSIONS_FAILED":
    return {
      ...state,
      professions: INITIAL_STATE.professions,
      is_professions_loading: false
    };

  default:
    return state;
  }
};

function* loadDashboard({ payload }) {
  try {
    const response = yield axios.post(
      process.env.REACT_APP_API_URL + "/dashboard",
      {},
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );
    yield put({ type: "LOAD_DASHBOARD_SUCCESS", payload: response.data.data });
  } catch (err) {
    if (
      err.response &&
      err.response.data &&
      err.response.data.error &&
      err.response.data.error === "Failed to authenticate token."
    ) {
      window.location.href = "/logout";
    } else {
      yield put({ type: "LOAD_DASHBOARD_FAILED" });
    }
  }
}

function* loadCoupom({ payload }) {
  if (payload.coupom === "") {
    yield put({ type: "LOAD_COUPOM_SUCCESS", payload: {} });
    return;
  }

  try {
    const response = yield axios.post(
      process.env.REACT_APP_API_URL + "/coupons/validate",
      payload,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );
    yield put({ type: "LOAD_COUPOM_SUCCESS", payload: response.data.data });
  } catch {
    yield put({ type: "LOAD_COUPOM_FAILED" });
  }
}

function* loadStates({ payload }) {
  try {
    const response = yield axios.get(
      process.env.REACT_APP_API_URL + "/locations/states",
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );
    yield put({ type: "LOAD_STATES_SUCCESS", payload: response.data.data });
  } catch {
    yield put({ type: "LOAD_STATES_FAILED" });
  }
}

function* loadCities({ payload }) {
  try {
    if (payload.state === "" || payload.state === null) {
      yield put({ type: "LOAD_CITIES_SUCCESS", payload: [] });
      return true;
    }
    const response = yield axios.get(
      process.env.REACT_APP_API_URL + `/locations/cities/${payload.state}`,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    yield put({ type: "LOAD_CITIES_SUCCESS", payload: response.data.data });
    if (payload.callback !== undefined) payload.callback(response.data.data);
  } catch {
    yield put({ type: "LOAD_CITIES_FAILED" });
  }
}

/* removed: reportReview (deprecated) */

/* removed: reportCorrection (Atualização simples deprecated) */

/* removed: reportCorrectionFgts (FGTS deprecated) */

/* removed: reportCorrectionComplete (Atualização completa deprecated) */

/* removed: reportChildcare (Pensao deprecated) */

function* saveCustomer({ payload }) {
  try {
    yield axios.post(
      process.env.REACT_APP_API_URL + "/client_customers",
      payload.submitValues,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );
    payload.setSubmitting(false);
    toast.success("Cliente salvo com sucesso!");
    payload.callback();
  } catch {
    toast.error("Ocorreu um erro ao salvar o cliente, tente novamente.");
    payload.setSubmitting(false);
  }
}

function* loadCustomer({ payload }) {
  try {
    const response = yield axios.get(
      process.env.REACT_APP_API_URL + "/client_customers/" + payload.id,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );
    yield put({ type: "LOAD_CUSTOMER_SUCCESS", payload: response.data.data });
  } catch {
    yield put({ type: "LOAD_CUSTOMER_FAILED" });
    toast.error(
      "Ocorreu um erro ao carregar os dados do cliente, tente novamente."
    );
  }
}

function* loadProfessions({ payload }) {
  try {
    const response = yield axios.get(
      process.env.REACT_APP_API_URL + "/professions",
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );
    yield put({
      type: "LOAD_PROFESSIONS_SUCCESS",
      payload: response.data.data
    });
  } catch {
    yield put({ type: "LOAD_PROFESSIONS_FAILED" });
    toast.error("Ocorreu um erro ao carregar as profissões, tente novamente.");
  }
}

/* removed: loadOpportunities (opportunities listing deprecated) */

function* saveUser({ payload }) {
  try {
    const response = yield axios.post(
      config.app.adminBaseUrl + "/auth/register",
      payload.submitValues,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    payload.setSubmitting(false);
    if (!response.data.success) {
      toast.error(response.data.message);
      return false;
    }

    toast.success(
      "Cadastro realizado com sucesso! Realize login na nossa plataforma."
    );
    payload.callback();
  } catch (err) {
    console.log(err);
    toast.error(
      "Ocorreu um erro ao salvar o seu cadastro, por favor, tente novamente."
    );
    payload.setSubmitting(false);
  }
}

function* adminSaveUser({ payload }) {
  try {
    const response = yield axios.post(
      config.app.adminBaseUrl + "/clients",
      payload.submitValues,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    payload.setSubmitting(false);
    if (!response.data.success) {
      toast.error(response.data.message);
      return false;
    }

    toast.success("Cadastro realizado com sucesso!.");
    payload.callback();
  } catch (err) {
    toast.error(
      err?.response?.data?.message ||
      "Ocorreu um erro ao salvar o cadastro, por favor, tente novamente."
    );
    payload.setSubmitting(false);
  }
}

function* adminDeleteUser({ payload }) {
  try {
    const response = yield axios.delete(
      `${config.app.adminBaseUrl}/clients/${payload.id}`,
      {
        data: {
          reason: payload.reason
        },
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    if (response.status < 200 || response.status >= 300) {
      toast.error(response.data?.message ?? "Erro ao excluir usuário.");
      return false;
    }

    toast.success(response.data?.message ?? "Usuário excluído com sucesso.");
  } catch (err) {
    toast.error(
      "Ocorreu um erro ao excluir o cadastro, por favor, tente novamente."
    );
  }
}

function* saveOpportunity({ payload }) {
  try {
    yield axios.post(
      process.env.REACT_APP_API_URL + "/opportunities",
      payload.submitValues,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );
    payload.setSubmitting(false);
    toast.success("Solicitação enviada com sucesso!");
    payload.callback();
  } catch (err) {
    console.log(err);
    toast.error(
      "Ocorreu um erro ao salvar seus dados, por favor, tente novamente."
    );
    payload.setSubmitting(false);
  }
}

/* removed: unlockOpportunity (opportunities unlock deprecated) */

function* queryValidateDocument({ payload }) {
  try {
    const response = yield axios.post(
      process.env.REACT_APP_API_URL + "/queries/validate",
      {
        document: payload.document
      },
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    if (!response.data.success) {
      yield put({ type: "QUERY_VALIDATE_DOCUMENT_FAILED" });
      toast.warn(response.data.msg);
      return false;
    }

    yield put({
      type: "QUERY_VALIDATE_DOCUMENT_SUCCESS",
      payload: {
        available_products: response.data.available_products,
        document_type: response.data.document_type,
        document_number: response.data.document_number
      }
    });
    payload.callback();
  } catch (err) {
    toast.error(
      "Ocorreu um erro ao realizar a consulta, por favor, tente novamente."
    );
    yield put({ type: "QUERY_VALIDATE_DOCUMENT_FAILED" });
  }
}

function* queryCheckout({ payload }) {
  try {
    const response = yield axios.post(
      process.env.REACT_APP_API_URL + "/queries/checkout",
      payload.values,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    yield put({
      type: "QUERY_CHECKOUT_SUCCESS",
      payload: response.data
    });
    payload.onResponse();
    if (payload.setSubmitting !== undefined) payload.setSubmitting(false);
  } catch (err) {
    yield put({
      type: "QUERY_CHECKOUT_FAILED"
    });
    toast.error(
      "Ocorreu um erro ao realizar sua compra, por favor, tente novamente."
    );
    if (payload.setSubmitting !== undefined) payload.setSubmitting(false);
  }
}

function* activateAccount({ payload }) {
  try {
    const response = yield axios.post(
      process.env.REACT_APP_API_URL + "/auth/validation",
      { token: payload.token },
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    if (!response.data.success) {
      toast.error(response.data.msg);
      yield put({ type: "ACTIVATE_ACCOUNT_FAILED", payload: response.data });
      return;
    }

    yield put({ type: "ACTIVATE_ACCOUNT_SUCCESS", payload: response.data });
    toast.success("Conta ativada com sucesso!");
  } catch (err) {
    console.log(err);

    yield put({
      type: "ACTIVATE_ACCOUNT_FAILED",
      payload: {
        success: false,
        msg:
          "Ocorreu um erro ao verificar sua conta, por favor, tente novamente"
      }
    });
  }
}

function* loadCards({ payload }) {
  try {
    const response = yield axios.get(
      config.app.adminBaseUrl + `/clients/${payload.client_id}/cards`,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    if (!response.data.success) {
      yield put({ type: "LOAD_CARDS_FAILED", payload: response.data.data });
      toast.warning(
        "Não foi possivel encontrar cartão no Provedor de Pagamento"
      );
      return;
    }

    yield put({ type: "LOAD_CARDS_SUCCESS", payload: response.data.data });
  } catch (err) {
    console.log(err);
    yield put({ type: "LOAD_CARDS_FAILED" });
  }
}

function* loadClientPlanOffers({ payload }) {
  const putEmptyOffers = function* putEmptyOffers() {
    yield put({
      type: "LOAD_CLIENT_PLAN_OFFERS_SUCCESS",
      payload: [],
    });
  };

  try {
    const response = yield axios.get(
      process.env.REACT_APP_API_URL +
        `/subscription/plans/offers/${payload.client_id}`,
      {
        headers: {
          "x-trace-id": generateTraceId(),
        },
      },
    );

    if (!response.data?.success) {
      if (isJusSubNotFoundResponse(response.data)) {
        yield* putEmptyOffers();
        return;
      }
      yield put({ type: "LOAD_CLIENT_PLAN_OFFERS_FAILED" });
      return;
    }

    yield put({
      type: "LOAD_CLIENT_PLAN_OFFERS_SUCCESS",
      payload: mapOffersToAdminPlans(response.data.data)
    });
  } catch (err) {
    if (isJusSubNotFoundResponse(err?.response?.data)) {
      yield* putEmptyOffers();
      return;
    }
    console.log(err);
    yield put({ type: "LOAD_CLIENT_PLAN_OFFERS_FAILED" });
  }
}

export function* loadClientSubscription({ payload }) {
  try {
    const response = yield call(getClientSubscriptionV2, payload.id);

    if (!response.success) {
      yield put({
        type: "LOAD_CLIENT_SUBSCRIPTION_FAILED",
        payload: response,
      });
      toast.error(
        "Ocorreu um erro ao carregar os dados do cliente, tente novamente.",
      );
      return;
    }

    const mapped = mapSubscriptionV2Response(response.data);

    if (!mapped) {
      yield put({ type: "LOAD_CLIENT_SUBSCRIPTION_FAILED" });
      toast.error(
        "Ocorreu um erro ao carregar os dados do cliente, tente novamente.",
      );
      return;
    }

    yield put({
      type: "LOAD_CLIENT_SUBSCRIPTION_SUCCESS",
      payload: mapped,
    });
  } catch (err) {
    console.log(err);
    yield put({ type: "LOAD_CLIENT_SUBSCRIPTION_FAILED" });
    toast.error(
      "Ocorreu um erro ao carregar os dados do cliente, tente novamente.",
    );
  }
}

function* saveProfile({ payload }) {
  try {
    yield axios.post(
      config.app.adminBaseUrl + "/clients/update-profile",
      payload,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    toast.success("Perfil atualizado com sucesso!");
  } catch (err) {
    let errorMessage =
      "Ocorreu um erro ao salvar o perfil do cliente, tente novamente.";

    if (err.response && err.response.data) {
      if (err.response.status === 422 && err.response.data.details) {
        const details = err.response.data.details;

        const errorKeys = Object.keys(details);

        if (errorKeys.length > 0) {
          errorMessage = details[errorKeys[0]];
        }
      } else if (err.response.status === 409 && err.response.data.msg) {
        errorMessage = err.response.data.msg;
      }
    }
    toast.error(errorMessage);
  }

  payload.callback();
}

function* deleteCard({ payload }) {
  try {
    const response = yield axios.delete(
      `${process.env.REACT_APP_API_URL}/subscription/cards/remove/${payload.id}`,
      {
        data: { client_id: payload.client_id },
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    if (response.data.success === false) {
      toast.error(response.data.msg);
    } else {
      yield put({
        type: "LOAD_CARDS",
        payload: { client_id: payload.client_id }
      });
      toast.success("Cartão excluído com sucesso!");
    }
  } catch (err) {
    toast.error("Ocorreu um erro ao excluir o cartão, tente novamente.");
  }
}

function* setPrimaryCard({ payload }) {
  try {
    const { cardId, client_id, callback } = payload || {};

    const response = yield axios.post(
      config.app.adminBaseUrl + `/clients/${client_id}/cards/${cardId}/set-primary`,
      {},
      {
        headers: {
          "x-trace-id": generateTraceId(),
        },
      },
    );

    if (!response?.data?.success) {
      const message =
        response?.data?.msg ||
        "Não foi possível definir o cartão principal, tente novamente.";
      toast.error(message);
      yield put({ type: "LOAD_CARDS", payload: { client_id } });
      callback?.(response);
      return;
    }

    toast.success("Cartão principal atualizado com sucesso!");
    yield put({ type: "LOAD_CARDS", payload: { client_id } });
    callback?.(response);
  } catch (error) {
    toast.error(
      "Ocorreu um erro ao definir o cartão principal, tente novamente.",
    );
    yield put({
      type: "LOAD_CARDS",
      payload: { client_id: payload?.client_id },
    });
    payload?.callback?.(error?.response);
  }
}

export function* saga() {
  yield takeLatest("ACTIVATE_ACCOUNT", activateAccount);
  yield takeLatest("LOAD_CARDS", loadCards);
  // yield takeLatest("LOAD_CARDS_V2", loadCardsV2);
  yield takeLatest("LOAD_CLIENT_SUBSCRIPTION", loadClientSubscription);
  yield takeLatest("LOAD_CLIENT_PLAN_OFFERS", loadClientPlanOffers);
  yield takeLatest("SAVE_PROFILE", saveProfile);
  yield takeLatest("QUERY_CHECKOUT", queryCheckout);
  yield takeLatest("LOAD_DASHBOARD", loadDashboard);
  yield takeLatest("QUERY_VALIDATE_DOCUMENT", queryValidateDocument);
  yield takeLatest("LOAD_STATES", loadStates);
  yield takeLatest("LOAD_CITIES", loadCities);
  yield takeLatest("SAVE_CUSTOMER", saveCustomer);
  yield takeLatest("LOAD_CUSTOMER", loadCustomer);
  yield takeLatest("LOAD_PROFESSIONS", loadProfessions);
  yield takeLatest("SAVE_USER", saveUser);
  yield takeLatest("ADMIN_SAVE_USER", adminSaveUser);
  yield takeLatest("ADMIN_DELETE_USER", adminDeleteUser);
  yield takeLatest("SAVE_OPPORTUNITY", saveOpportunity);
  yield takeLatest("LOAD_COUPOM", loadCoupom);
  yield takeLatest("DELETE_CARD", deleteCard);
  yield takeLatest("SET_PRIMARY_CARD", setPrimaryCard);
}
